export { default } from './StrategyProfileMarker';
